module.exports = __webpack_public_path__ + "static/media/12-2.943cbcec.mp3";